import { ArrowDownIcon } from 'components/Icon/icons/arrow-down'
import React, { useState } from 'react'
import { View } from 'components/View'
import TextBody from 'components/TextBody'
import Button from 'components/Button'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

/**
 * @param props
 * @param props.question
 * @param props.answer
 * @param props.isDesktopStylingEnabled
 * @return {Element}
 * @constructor
 */
export default function FAQItem (props) {
  const {
    question,
    answer,
    isDesktopStylingEnabled
  } = props
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const [isExpanded, setIsExpanded] = useState(false)
  const isResponsive = !isSmallScreen && isDesktopStylingEnabled

  return (
    <View
      mb={2}
      mW='600px'
      w={isSmallScreen ? '100%' : '600px'}
    >

      <Button
        w='100%'
        h='unset'
        style={{
          maxWidth: 'unset',
          borderTopLeftRadius: '0.625rem',
          borderTopRightRadius: '0.625rem',
          borderBottomRightRadius: isExpanded ? 0 : '0.625rem',
          borderBottomLeftRadius: isExpanded ? 0 : '0.625rem',
          justifyContent: 'space-between',
          display: 'flex',
          backgroundColor: '#F3F3F3',
          alignItems: 'center',
          paddingTop: !isResponsive ? '2.42rem' : '3.76rem',
          paddingBottom: !isResponsive ? '2.42rem' : '3.76rem',
          paddingLeft: !isResponsive ? '1.245rem' : '3.245rem',
          paddingRight: !isResponsive ? '1.245rem' : '3.245rem'
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <TextBody
          fw='500'
          fs={!isResponsive ? '1rem' : '1.5rem'}
          style={{
            textAlign: 'left'
          }}
        >
          {question}
        </TextBody>
        <View
          h={!isResponsive ? '0.844rem' : '1.267rem'}
          w={!isResponsive ? '0.844rem' : '1.267rem'}
          p='1rem'
          mr='-1rem'
          d='flex'
          row
          ac
          jc
        >
          <ArrowDownIcon
            style={{
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: '1s'
            }}
          />
        </View>
      </Button>

      {
        isExpanded && (
          <View
            pb={!isResponsive ? '1.82rem' : '3.9rem'}
            pl={!isResponsive ? '1.245rem' : '3.245rem'}
            pr={!isResponsive ? '1.245rem' : '3.245rem'}
            mb={!isResponsive ? '0.243rem' : '0.75rem'}
            bgc='#F3F3F3'
            style={{
              borderTopLeftRadius: isExpanded ? 0 : '0.625rem',
              borderTopRightRadius: isExpanded ? 0 : '0.625rem',
              borderBottomRightRadius: '0.625rem',
              borderBottomLeftRadius: '0.625rem',
              zIndex: 1
            }}
          >
            <TextBody
              fs={!isResponsive ? '1rem' : '1.5rem'}
              c='#676767'
              fw='400'
              style={{ lineHeight: '147.3%' }}
            >
              {answer}
            </TextBody>
          </View>
        )
      }
    </View>
  )
}
